import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { AuthorizationCheck } from '../utils/AuthorizationCheck';

const Dashboard = ({ auth, history }) => {

  const hasDirectoryAccess = (directory) => {
    // Check both auth.directories and auth.ek_permission.directories
    const directories = auth?.directories || auth?.ek_permission?.directories;
    if (!auth || !directories) return false;
    return directories.some(dir => dir === '/*' || dir === directory);
  };

  const accessCards = [
    {
      title: 'Admin Console',
      description: 'Users, AI models, and system configuration',
      icon: '⚙️',
      route: '/admin/console',
      directory: '/*', // Admin only
      available: auth && auth.role === 'admin'
    },
    {
      title: 'AI Notes Admin',
      description: 'Create and manage AI Notes posts',
      icon: '📝',
      route: '/admin/ai-notes',
      directory: '/*', // Admin only
      available: auth && auth.role === 'admin'
    },
    {
      title: 'Article to Media Admin',
      description: 'Manage articles, access codes, and analytics',
      icon: '🛠️',
      route: '/admin/tools',
      directory: '/*', // Admin only
      available: auth && auth.role === 'admin'
    },
    {
      title: 'Jo XYZ Demo',
      description: 'Protected demo area for Jo XYZ',
      icon: '🔒',
      route: '/jo-xyz-demo',
      directory: '/jo-xyz-demo',
      available: auth && (auth.role === 'admin' || hasDirectoryAccess('/jo-xyz-demo'))
    }
  ];

  const handleCardClick = (route) => {
    history.push(route);
  };

  // Check if user has access to dashboard (no specific directory required)
  const renderPage = AuthorizationCheck(auth);

  if (!renderPage) {
    return null; // AuthorizationCheck handles the redirect
  }

  return (
      <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Dashboard - Elliot Koss</title>
      </Helmet>
      <Container style={{ paddingTop: '100px' }}>
        <Row>
          <Col>
            <div>
              <h2>Welcome back, {auth?.first_name || 'User'}!</h2>
              <p className="text-muted">Here's what you have access to:</p>
            </div>
          </Col>
        </Row>
        
        <Row className="mt-4">
          {accessCards.filter(card => card.available).map((card, index) => (
            <Col md={6} lg={4} key={index} className="mb-4">
              <Card 
                className="h-100 border-primary"
                style={{ cursor: 'pointer' }}
                onClick={() => handleCardClick(card.route)}
              >
                <Card.Body className="text-center">
                  <div className="display-4 mb-3">{card.icon}</div>
                  <Card.Title>{card.title}</Card.Title>
                  <Card.Text className="text-muted">
                    {card.description}
                  </Card.Text>
                  <Button variant="primary" size="sm">
                    Access
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

      </Container>
      </>
  );
};

function mapStateToProps({ auth }) {
  return { auth };
}

export default withRouter(connect(mapStateToProps)(Dashboard));
